const getAreDaysExpired = (selectedPlan) => {
  if (selectedPlan.expire_days != null) {
    return Number.isInteger(selectedPlan.expire_days) && selectedPlan.expire_days <= 0;
  }
  return false;
};

const emptyPlanInfo = {
  areDaysExpired: false,
  isTrialActive: false,
  isTrialExpired: false,
  isProActive: false,
  isAAClient: false,
  hasClientUsedTrial: undefined,
  isTurbo: false,
  hasInvoice: false,
};

export const getSelectedPlanInfo = (selectedPlan) => {
  if (!selectedPlan) {
    return { ...emptyPlanInfo };
  }

  const areDaysExpired = getAreDaysExpired(selectedPlan);
  const isTrialActive = selectedPlan.is_trial && !areDaysExpired;
  const isTrialExpired = areDaysExpired;
  const isAAClient = selectedPlan.trial_days === 365;
  const hasClientUsedTrial = selectedPlan.trial_used;
  const sharedHostingPlan = selectedPlan.shared_hosting_plan;
  const isTurbo = Boolean(
    sharedHostingPlan && sharedHostingPlan.toLowerCase().includes('turbo'),
  );
  const hasInvoice = Boolean(selectedPlan.invoice);

  return {
    areDaysExpired,
    isTrialActive,
    isTrialExpired,
    isProActive: selectedPlan.is_pro,
    isAAClient,
    hasClientUsedTrial,
    isTurbo,
    hasInvoice,
    invoiceId: selectedPlan.invoice,
  };
};
